












import { Component, Mixins, Prop } from "vue-property-decorator";
import {
  IItem,
  IFontSizeAutoAdjustable,
  instanceOfIFontSizeAutoAdjustable,
  instanceOfIFreeInputable,
} from "../../../../domain/document/items";
import {
  ModelEditableMixin,
  ModalPresentableMixin,
} from "../../../system/mixins";
import { ExtraPageDialogsAccessor } from "../CommonComponentsAccessor";
import {
  DocumentStructureEditableMixin,
  ExtraDocumentEditableMixin
} from "../mixins";
import OverflowedTextPageExtender from "./OverflowedTextPageExtender.vue";
import { EditingDocument } from "..";

@Component({
  components: {
    OverflowedTextPageExtender,
  }
})
export default class ExtraPageEditor extends Mixins(
  ModelEditableMixin,
  DocumentStructureEditableMixin,
  ExtraDocumentEditableMixin,
  ModalPresentableMixin,
) {
  editingSource: EditingDocument;

  @Prop()
  dialogs: ExtraPageDialogsAccessor;

  data() {
    return {
      isProcessing: false,
      overflowedTextPageExtender: null as OverflowedTextPageExtender,
    };
  }
  isProcessing: boolean;
  overflowedTextPageExtender: OverflowedTextPageExtender;

  mounted(): void {
    this.overflowedTextPageExtender = this.$refs.overflowedTextPageExtender as OverflowedTextPageExtender;
  }

  async addExtraPageAfterCurrentPage(): Promise<boolean> {
    try {
      if (!this.isExtraPageAddible) {
        return false;
      }
      const nextSectionIndex = this.editingSource.currentSectionIndex + 1;
      const sectionLength = this.sections.length;
      const destinationSectionIndex = this.isExtendedPagePositionSelectable
        ? await this.dialogs.positionSelector.show("", nextSectionIndex, sectionLength)
        : sectionLength;
      if (destinationSectionIndex === null || destinationSectionIndex === undefined) {
        return false;
      }
      const document = await this.dialogs.documentSelector.show(this.editingSource.attributes.patient, this.extraFormats, this.getExtraDocument);
      if (!document) {
        return false;
      }
      this.isProcessing = true;
      try {
        await this.mergeExtraDocument(document, destinationSectionIndex);
        return true;
      } catch (e) {
        this.$error(
          "続紙追加失敗",
          "続紙の追加に失敗しました。",
          e,
        );
        return false;
      }
    } catch (e) {
      this.$error(
        "続紙読込失敗",
        "指定された続紙の情報を取得できませんでした。",
        e,
      );
      return false;
    } finally {
      this.isProcessing = false;
    }
  }

  async removeCurrentPage(): Promise<boolean> {
    try {
      if (!this.isExtraPageRemovable) {
        return false;
      }
      this.beginModal();
      const index = await this.$commonDialogs.confirmation.confirmDeleteCancel(
        "続紙ページ削除確認",
        ["表示中のページを削除します。本当によろしいですか？"]
      );
      if (index !== 0) { return false; }
      this.removeExtraSection(this.currentSection);
      this.$success(
        "続紙ページ削除完了",
        "ページを削除しました。",
      );
      return true;
    } catch (e) {
      return false;
    } finally {
      this.endModal();
    }
  }

  async addOverflowedTextPage(source: IItem): Promise<boolean> {
    return this.overflowedTextPageExtender.addOverflowedTextPage(
      this.itemSetId,
      this.currentSectionIndex,
      source as IFontSizeAutoAdjustable);
  }

  async addAllOverflowedTextPage(): Promise<void> {
    await this.overflowedTextPageExtender.addAllOverflowedTextPage();
  }

  isAddibleOverflowedTextPage(source: IItem): boolean {
    return instanceOfIFontSizeAutoAdjustable(source)
        && source.enabledAutoAdjustFontSize
        && instanceOfIFreeInputable(source)
        && !source.shouldInputFree;
  }
}
